module.exports = "/static/assets/0729deeeab0ba3942fba6f70ed338969.png";